/**
 * Queue V2 Repository - GraphQL Queries
 *
 * 6 query operations for Queue primitive data access.
 */

import { gql } from '@apollo/client';
import { QUEUE_FIELDS_FRAGMENT } from './fragments';

export const GET_QUEUE = gql`
  ${QUEUE_FIELDS_FRAGMENT}
  query GetQueue($tenantId: String!, $queueId: String!) {
    getQueue(tenantId: $tenantId, queueId: $queueId) {
      ...QueueFields
    }
  }
`;

export const LIST_QUEUES = gql`
  ${QUEUE_FIELDS_FRAGMENT}
  query ListQueues($tenantId: String!, $limit: Int, $cursor: String) {
    listQueues(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      items {
        ...QueueFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

export const GET_QUEUES_BY_WORKFLOW_INSTANCE = gql`
  ${QUEUE_FIELDS_FRAGMENT}
  query GetQueuesByWorkflowInstance($tenantId: String!, $workflowInstanceId: String!) {
    getQueuesByWorkflowInstance(tenantId: $tenantId, workflowInstanceId: $workflowInstanceId) {
      ...QueueFields
    }
  }
`;

export const GET_QUEUE_STATISTICS = gql`
  query GetQueueStatistics($tenantId: String!, $queueId: String!) {
    getQueueStatistics(tenantId: $tenantId, queueId: $queueId) {
      queueId
      currentSize
      utilizationPercent
      avgWaitTimeSeconds
      processingRatePerHour
      slaBreachCount
      isOverThreshold
    }
  }
`;

export const GET_OVERLOADED_QUEUES = gql`
  ${QUEUE_FIELDS_FRAGMENT}
  query GetOverloadedQueues($tenantId: String!) {
    getOverloadedQueues(tenantId: $tenantId) {
      ...QueueFields
    }
  }
`;

export const GET_QUEUES_WITH_SLA_BREACHES = gql`
  ${QUEUE_FIELDS_FRAGMENT}
  query GetQueuesWithSLABreaches($tenantId: String!) {
    getQueuesWithSLABreaches(tenantId: $tenantId) {
      ...QueueFields
    }
  }
`;
